import { RootState } from "@/app/stores"
import { createSelector } from "@reduxjs/toolkit"

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.fillProfile
)

export const selectFillProfileIsOpen = createSelector(baseSelector, s => s.isOpen)
export const selectFillProfileCurrentUser = createSelector(baseSelector, s => s.currentUser)
export const selectFillProfileOnSuccess = createSelector(baseSelector, s => s.onSuccess)
